module.exports = __webpack_public_path__ + "static/media/Burrito de carne asada con Mayonesa.5163fad3.webp";